import { MyOptionType } from '@procsea/design-system'

import { useCurrentVertical } from 'src/hooks'
import { useLabelsQuery } from 'src/queries/shared'
import { Label } from 'src/types'

export const selectLabelOptions = (units: Label[]): MyOptionType<Label>[] =>
  units.map(label => ({ label: label.name, value: label }))

const useLabelOptions = () => {
  const currentVerticalId = useCurrentVertical()?.id

  const {
    data: labelOptions,
    isSuccess,
    isInitialLoading,
  } = useLabelsQuery({
    queryParams: { verticalId: currentVerticalId },
    queryOptions: {
      enabled: !!currentVerticalId,
      select: selectLabelOptions,
    },
  })

  return { labelOptions, isSuccess, isInitialLoading }
}

export default useLabelOptions
